export default "__VITE_ASSET__2ebb9498__"